import { createContext } from 'react';
import { getCookie } from '../../helper/cookieClient';

const userProfile = {
  name: '',
  language:
    getCookie('lang') ||
    navigator.language ||
    navigator.browserLanguage ||
    'en',
  changeLanguage: () => {},
  setUserInfo: () => {}
};

const UserContext = createContext(userProfile);

export default UserContext;



// WEBPACK FOOTER //
// ./src/components/context/UserContext.js